import { render, staticRenderFns } from "./ClubChatCopies.vue?vue&type=template&id=4d8018ba&"
import script from "./ClubChatCopies.vue?vue&type=script&lang=js&"
export * from "./ClubChatCopies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports